import React, { useEffect, useState } from 'react'
import RishikeshHead from './RishikeshHead';
// import RishikeshBigimage from './RishikeshBigimage';
import RishikeshDining from './RishikeshDining';
import RishikeshBook from './RishikeshBook';
import RishikeshAbout from './RishikeshAbout';
import RishikeshVideo from './RishikeshVideo';
import RishikeshNearby from './RishikeshNearby';
import RishikeshAvailability from './RishikeshAvailability';
import RishikeshPlace from './RishikeshPlace';
import RishikeshRooms from './RishikeshRooms';
import RishTestimonial from './RishTestimonial';
import RishikeshBanner from './RishikeshBanner';
import GoaGallery from '../Goa/GoaGallery';
// import OfferPopup from '../../component/OfferPopup';

export default function Rishikesh() {
// const [showPopup, setShowPopup] = useState(false);

// useEffect(() => {
//   setShowPopup(true);
// }, []);

// const handleClose = () => {
//   setShowPopup(false);
// };


  const bannerData = {
    images: [
      { img: "/image/rishikesh-banner-1.webp" },
      { img: "/image/rishikesh-banner-2.webp" },
      { img: "/image/rishikesh-banner-3.webp" },
      { img: "/image/rishikesh-banner-2.webp" },
    ],
    buttonLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="
  };


  const quoteHead = {
    title: "Resort De Coração Tapovan rishikesh",
    desc: "Nestled in the serene foothills of the Shivalik range. A timeless retreat that honors and celebrates Rishikesh's ancient spiritual essence and the profound sense of peace it awakens.",
  };


  const aboutData = {
    title: "Making Memories",
    heading: "Dawn yoga sessions. Twilight aarti ceremonies. Temple meditation. Ancient trail walks. Exhilarating rafting.",
    desc: "Experience Rishikesh, where the holy Ganges meets the Shivaliks. Begin with dawn yoga sessions, witness twilight aarti ceremonies, explore temples and trail walks, or enjoy exhilarating rafting as spirituality meets modern wellness luxury.",
    Linktext: "Explore Resort",
    Link: "",
    Image1: "/image/rishikesh-about-1.webp",
    Image2: "/image/rishikesh-about-2.webp",
  }


  // const bigimageData = {
  //     heading: "Where Traditions Unite with Tranquility",
  //     desc: "Exchange vows beside the sacred Ganges, celebrate under Shivaliks skies, and create unforgettable moments in our enchanting venue. Every detail thoughtfully crafted where spiritual blessings meet contemporary elegance and timeless romance.",
  //     image: "/image/rishikesh-bigimage.webp",
  //     shape: "",
  //     // shape: "/image/bigimage-shape.webp",
  // }



  const nearbyData = [
    {
      img: "/image/rishikesh-attaraction-1.webp",
      title: "Devprayag",
      distance: "1 hr 54 min",
    },
    {
      img: "/image/rishikesh-attaraction-2.webp",
      title: "Triveni Ghat",
      distance: "4.5 km",
    },
    {
      img: "/image/rishikesh-attaraction-3.webp",
      title: "Beatles Ashram",
      distance: "3.7 km",
    },
    {
      img: "/image/rishikesh-attaraction-4.webp",
      title: "Vashistha Cave",
      distance: "17.7 km",
    },
  ];


// const offerPopupData = {
//   leftImage: "/image/offer-left-image-3.webp",
//   mobileImage: "/image/offer-left-mobile-image.webp",
//   label: "brand website",
//   title: "exclusive",
//   highlight: "offer", 
//   description:
//     "Enjoy exclusive benefits when you book directly through our Brand Website.",

// benefits: [
//     {
//       icon: "/image/offerpopup-icon-1.webp",
//       text1: "15% OFF",
//       text2: "on Food & Beverages",
//     },
//     {
//       icon: "/image/offerpopup-icon-4.webp",
//       text1: "Complimentary Upgrade from",
//       text2: "Deluxe to Super Deluxe",
//     },
//     {
//       icon: "/image/offerpopup-icon-5.webp",
//       text1: "Subject to availability",
//       text2: "Early Check-in & Late Check-out",
//     },
//     {
//       icon: "/image/offerpopup-icon-9.webp",
//       text1: "Complimentary </br> Hi-Tea",
//       text2: "For CP & MAP bookings",
//     },
//     // {
//     //   icon: "/image/offerpopup-icon-5.webp",
//     //   text1: "Early Check-In & Late Check Out",
//     //   text2: "Subject to Avaliblity",
//     // },
//     // {
//     //   icon: "/image/offerpopup-icon-6.webp",
//     //   text1: "2 Pints of Beer",
//     //   text2: "on arrival",
//     // },   
//   ],
// };


const testimonialData = [
    {
        text: "De Coração was the perfect base for experiencing Rishikesh. The peaceful setting helped us slow down, while everything we wanted to explore was within easy reach.",
        image: "/image/Aditya-Verma.webp",
        name: "Aditya Verma",
        designation: "Lucknow",
    },
    {
        text: "The stay gave us a beautiful balance of comfort and tranquillity. After exploring Rishikesh, returning to such a calm space felt incredibly refreshing.",
        image: "/image/Meera-Nair.webp",
        name: "Meera Nair",
        designation: "Kochi", 
    },
    {
        text: "We came to Rishikesh looking for a little peace and found exactly that. The thoughtful hospitality and serene surroundings made our stay deeply relaxing.",
        image: "/image/Siddharth-Kapoor.webp",
        name: "Siddharth Kapoor",
        designation: "Mumbai",
    },
    {
        text: "From the peaceful mornings to the welcoming service, De Coração made our Rishikesh holiday feel effortless. It was comfortable, calming and beautifully located.",
        image: "/image/Kavya-Sharma.webp",
        name: "Kavya Sharma",
        designation: "Jaipur",
    },
    {
        text: "Our stay felt like a genuine pause from everyday life. The calm atmosphere, comfortable accommodation and warm hospitality made De Coração a memorable part of our Rishikesh experience.",
        image: "/image/Arjun-Malhotra.webp",
        name: "Arjun Malhotra",
        designation: "Bengaluru",
    },
];



const rishikeshGalleryImages = [
    { src: "/image/goa-gallery-1.webp", alt: "Goa gallery 1" },
    { src: "/image/goa-gallery-2.webp", alt: "Goa gallery 2" },
    { src: "/image/goa-gallery-3.webp", alt: "Goa gallery 3" },
    { src: "/image/goa-gallery-4.webp", alt: "Goa gallery 4" },
    { src: "/image/goa-gallery-5.webp", alt: "Goa gallery 5" },
    { src: "/image/goa-gallery-6.webp", alt: "Goa gallery 6" },
    { src: "/image/goa-gallery-7.webp", alt: "Goa gallery 7" },
    { src: "/image/goa-gallery-8.webp", alt: "Goa gallery 8" },
];


  return (
    <>
      <RishikeshBanner bannerImages={bannerData.images} buttonLink={bannerData.buttonLink} />
      <RishikeshHead quoteHead={quoteHead} />
      <RishikeshAbout aboutData={aboutData} />
      <RishikeshBook />
      <RishikeshVideo />
      <RishikeshRooms />
      <RishikeshDining />
      {/* <RishikeshBigimage bigimageData={bigimageData}/> */}
      {/* <RishikeshPlace /> */}
      <RishikeshAvailability />
       {/* <GoaGallery images={rishikeshGalleryImages} heading="Rishikesh Gallery"/> */}
      <RishTestimonial testimonialData={testimonialData}/>
      <RishikeshNearby nearbyData={nearbyData} heading="Near By Attaraction" />

       {/* <OfferPopup show={showPopup} onHide={handleClose} data={offerPopupData}/> */}
    </>
  )
}
